import { render, staticRenderFns } from "./stat.vue?vue&type=template&id=71dc425a&"
import script from "./stat.vue?vue&type=script&lang=js&"
export * from "./stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports